import React, { useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Container,
} from "@material-ui/core";
import { NavLink } from "react-router-dom";
import * as Constants from "../Constants/Styles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import WorkOutlineRoundedIcon from "@material-ui/icons/WorkOutlineRounded";
import HttpRoundedIcon from "@material-ui/icons/HttpRounded";
import Repos from "../Components/Molecules/Repos";

const User = (props) => {
  const classes = Constants.useStyles();
  //USEEFFECT TO GET PARAMS
  useEffect(() => {
    props.getUser(props.match.params.login);
    props.getUserRepos(props.match.params.login);
  }, []);

  const {
    name,
    avatar_url,
    location,
    bio,
    company,
    blog,
    login,
    html_url,
    followers,
    following,
    public_repos,
    public_gists,
    hireable,
  } = props.user;
  const { loading } = props.loading;
  return (
    <Box>
      <IconButton>
        <NavLink to="/" className={classes.navLink}>
          <ArrowBackIcon color="secondary"></ArrowBackIcon>
        </NavLink>
      </IconButton>
      Hireable:{" "}
      {hireable ? (
        <i className="fa fa-check" style={{ color: "#0f0" }}></i>
      ) : (
        <i className="fa fa-times-circle" style={{ color: "#f00" }}></i>
      )}
      <Card className={classes.cardUserRoot} raised>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <div className={classes.cardUserImageContainer}>
              <CardMedia
                image={avatar_url}
                title={login}
                className={classes.cardUserImage}></CardMedia>
              <Typography variant="h5" align="center" color="textSecondary">
                {name}
              </Typography>
              <Typography variant="body1" align="center">
                Location: {location}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className={classes.cardContent}>
              {bio && (
                <Box>
                  <Typography variant="h5" align="center">
                    Bio
                  </Typography>
                  <Typography variant="body2" align="center" component="p">
                    {bio}
                  </Typography>
                </Box>
              )}
              <Box style={{ margin: "1rem auto" }}>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  href={html_url}
                  startIcon={<i className="fas fa-user-circle"></i>}>
                  Visit Github Profile
                </Button>
              </Box>
              <List className={classes.listRoot}>
                {login && (
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <AccountCircleIcon></AccountCircleIcon>
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Username"
                      secondary={login}></ListItemText>
                  </ListItem>
                )}
                {company && (
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <WorkOutlineRoundedIcon></WorkOutlineRoundedIcon>
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Company"
                      secondary={company}></ListItemText>
                  </ListItem>
                )}
                {blog && (
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <HttpRoundedIcon></HttpRoundedIcon>
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary="Website"
                      secondary={blog}></ListItemText>
                  </ListItem>
                )}
              </List>
            </Box>
          </Grid>
        </Grid>
      </Card>
      <Card className={classes.cardUserRoot} raised>
        <CardContent style={{ padding: "1rem", color: "#fff" }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={3} style={{ backgroundColor: "#2962ff" }}>
              <Typography variant="body1" align="center">
                Followers: {followers}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3} style={{ backgroundColor: "#00c853" }}>
              <Typography variant="body1" align="center">
                Following: {following}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3} style={{ backgroundColor: "#f44336" }}>
              <Typography variant="body1" align="center">
                Public Repos: {public_repos}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3} style={{ backgroundColor: "#37474f" }}>
              <Typography variant="body1" align="center">
                Public Gists: {public_gists}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <Repos repos={props.repos} className={classes.reposContainer}></Repos>
    </Box>
  );
};

export default User;
